import React, { FC } from "react";
import { ChannelOrderType } from "../../../types";
import { Box, Typography } from "@mui/material";

interface FutureBarProps {
  type: ChannelOrderType;
}

export const FutureBar: FC<FutureBarProps> = ({ type }) => {
  const getBackgroundColor = () => {
    if (type === "FUTURE_POSTS") {
      return "rgba(6, 174, 212, 0.12)";
    }

    if (type === "PAST_POSTS") {
      return "rgba(247, 144, 9, 0.12)";
    }
  };

  const getTextColor = () => {
    if (type === "FUTURE_POSTS") {
      return "rgb(14, 112, 144)";
    }
    if (type === "PAST_POSTS") {
      return "rgb(181, 71, 8)";
    }
  };

  const getText = () => {
    if (type === "FUTURE_POSTS") {
      return "future";
    }
    if (type === "PAST_POSTS") {
      return "past";
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mr: "8px",
      }}
    >
      <Typography
        sx={{
          fontSize: "0.8rem",
          display: "flex",
          alignItems: "center",
          backgroundColor: getBackgroundColor(),
          color: getTextColor(),
          px: "4px",
          borderRadius: "8px",
          height: "16px",
        }}
      >
        {getText()}
      </Typography>
    </Box>
  );
};
